import React from 'react';
import PropTypes from 'prop-types';
import { getCurrentStationCardDetails } from '../utils/ltsCardDetailsUtils';
import { CURRENT_STATION_DETAILS_CARD } from '../constants/LtsConstants';

import '../../../styles/CurrentStationDetails.css';

const CurrentStationDetail = ({
  customClass,
  onToggleBottomSheet,
  ltsPageState,
  clickRefreshHandler,
  updateTimeText,
  updateAgoDescription
}) => {
  const { currentStation, currentIntermediateStation, trainStartedFromSource } = {
    ...ltsPageState
  };

  if (!currentStation || !trainStartedFromSource) {
    return null;
  }
  const { stationName, isHalting, actualTime, crossedStationText, blackWatch } = getCurrentStationCardDetails({
    currentStation,
    currentIntermediateStation
  });

  const { HALT, NO_HALT } = CURRENT_STATION_DETAILS_CARD;

  return (
    <div className={`${customClass} currentStationDetail`} onClick={onToggleBottomSheet}>
      <section className={'currentStationTextContainer'}>
        <span className={`appendRight10 ${blackWatch ? 'railSeoSprite stopWatch' : 'railSeoSprite stopWatch--red'}`} />
        <div className={`${blackWatch ? 'blackText' : 'redText'} currentStationDetail__left`}>
          <span>{crossedStationText}</span>
          <div className="latoBold textOverflowEllipsis110"> {stationName} </div>
          <span className="latoBold"> {isHalting ? HALT : NO_HALT}</span>{' '}
          {isHalting && (
            <span>
              {' '}
              at <span className="latoBold">{actualTime}</span>
            </span>
          )}
        </div>
      </section>

      <section className="updatedTextContainer ">
        <div className="alignUpdatedText appendLeft15 makeFlex column noShrink appendRight12">
          <span className="blackText latoBold updatedTimeText">{updateTimeText}</span>
          <span className="updatedAgoDescriptionText">{updateAgoDescription}</span>
        </div>
        <span className="railSeoSprite blueReverse" onClick={clickRefreshHandler} />
      </section>
    </div>
  );
};

CurrentStationDetail.propTypes = {
  customClass: PropTypes.string,
  onToggleBottomSheet: PropTypes.func,
  ltsPageState: PropTypes.object,
  clickRefreshHandler: PropTypes.func,
  updateTimeText: PropTypes.string,
  updateAgoDescription: PropTypes.string
};

export default CurrentStationDetail;
